import { Filter, PostSource, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { Panel } from 'models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import { postCompositionConfigGrid } from 'components/Panel/PanelEditorSidebar/PanelDesign/PanelDesignOptions';
import { PostsWidgetOptions } from '../../widgets/PostsWidget/options';

export const TemplatePostEngagement3by2: Panel = {
    id: 'post-engagement-3-by-2',
    name: 'Posts by Social Network',
    description: '',
    tags: ['Content', 'Posts', 'Post Engagement', '3 By 2', 'Smart', 'landscape', 'portrait'],
    widget: {
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_engagement template_engagement_multi template_engagement_multi_3_by_2',
        children: [
            {
                type: 'postsGrid',
                id: '1',
                name: 'Post column 1',
                useGlobalTimePeriod: true,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                // Note: All global variables like reportingEngine, report, and filters
                                // are injected via PostRequest.getRequests()
                                id: new PostSource({
                                    pageSize: 36,
                                    filters: [
                                        new Filter({
                                            dimensionName: {
                                                LISTENING: 'LISTENING_MEDIA_TYPE',
                                                INBOUND_MESSAGE: 'SN_TYPE',
                                                PLATFORM: 'SN_TYPE',
                                                BENCHMARKING: 'BENCHMARKING_SN_TYPE',
                                            },
                                            values: {
                                                LISTENING: ['TWITTER'],
                                                INBOUND_MESSAGE: ['TWITTER'],
                                                PLATFORM: ['TWITTER'],
                                                BENCHMARKING: ['TWITTER#Twitter'],
                                            },
                                        }),
                                    ],
                                    sorts: [
                                        new Sort({
                                            order: 'DESC',
                                            heading: {
                                                LISTENING: 'REACH_COUNT',
                                                INBOUND_MESSAGE: 'INBOUND_COUNT',
                                                PLATFORM: 'TOTAL_ENGAGEMENT',
                                                BENCHMARKING: 'TOTAL_ENGAGEMENT',
                                                CAMPAIGN: 'OUTBOUND_STATUS',
                                                RDB_FIREHOSE: 'SN_CREATED_TIME',
                                                STORY_MESSAGE: 'IMPACT',
                                            },
                                        }),
                                    ],
                                    timePeriod: {
                                        key: 'last_7_days',
                                    },
                                }) as any,
                                options: {
                                    count: 300,
                                    imagePreload: true,
                                    removeDuplicates: true,
                                    shufflePosts: false,
                                    removeSensitivePosts: true,
                                    includeQuoteTweets: false,
                                },
                            },
                        ],
                        format: {
                            type: 'buckets',
                            options: {
                                padding: 1,
                                buckets: {
                                    text: { filter: "post.type == 'text'" },
                                    image: { filter: "post.type == 'image'" },
                                    any: { filter: 'post.type' },
                                },
                                panels: [{ total: 2, buckets: ['any', -1] }],
                            },
                        },
                    },
                ],
                position: {
                    height: '92.56%',
                    width: '31.94%',
                    top: '3.72%',
                    left: '2.08%',
                    portrait: {
                        height: '31.94%',
                        width: '95.84%',
                        top: '3.72%',
                        left: '2.08%',
                    },
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    } as any,
                    postTemplate: '',
                    userGroupEffect: 'top',
                    theme: 'primary',
                    postDirection: 'vertical',
                    showSentiment: true,
                    showText: true,
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                    postVersion: 2,
                    ...postCompositionConfigGrid.a,
                } as any,
                label: {
                    titleText: 'Twitter',
                    size: WIDGET_LABEL_SIZE.secondary,
                    enabled: true,
                },
            },
            {
                type: 'postsGrid',
                id: '2',
                name: 'Post column 2',
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                // Note: All global variables like reportingEngine, report, and filters
                                // are injected via PostRequest.getRequests()
                                id: new PostSource({
                                    pageSize: 50,
                                    filters: [
                                        new Filter({
                                            dimensionName: {
                                                LISTENING: 'LISTENING_MEDIA_TYPE',
                                                INBOUND_MESSAGE: 'SN_TYPE',
                                                PLATFORM: 'SN_TYPE',
                                                BENCHMARKING: 'BENCHMARKING_SN_TYPE',
                                            },
                                            values: {
                                                LISTENING: ['INSTAGRAM'],
                                                INBOUND_MESSAGE: ['INSTAGRAM'],
                                                PLATFORM: ['INSTAGRAM'],
                                                BENCHMARKING: ['INSTAGRAM#Instagram'],
                                            },
                                        }),
                                    ],
                                    sorts: [
                                        new Sort({
                                            order: 'DESC',
                                            heading: {
                                                LISTENING: 'REACH_COUNT',
                                                INBOUND_MESSAGE: 'INBOUND_COUNT',
                                                PLATFORM: 'TOTAL_ENGAGEMENT',
                                                BENCHMARKING: 'TOTAL_ENGAGEMENT',
                                                CAMPAIGN: 'OUTBOUND_STATUS',
                                            },
                                        }),
                                    ],
                                    timePeriod: {
                                        key: 'last_7_days',
                                    },
                                }) as any,
                                options: {
                                    count: 300,
                                    imagePreload: true,
                                    removeDuplicates: true,
                                    shufflePosts: false,
                                    removeSensitivePosts: true,
                                },
                            },
                        ],
                        format: {
                            type: 'buckets',
                            options: {
                                padding: 1,
                                buckets: {
                                    text: { filter: "post.type == 'text'" },
                                    image: { filter: "post.type == 'image'" },
                                    any: { filter: 'post.type' },
                                },
                                panels: [{ total: 2, buckets: ['any', -1] }],
                            },
                        },
                    },
                ],

                // top: '3.72%',
                // left: '2.08%',
                // height: '92.56%',
                // width: '95.84%'

                position: {
                    height: '92.56%',
                    width: '31.94%',
                    top: '3.72%',
                    left: '34.03%',
                    portrait: {
                        height: '31.94%',
                        width: '95.84%',
                        top: '34.03%',
                        left: '2.08%',
                    },
                },
                options: Object.assign(
                    {
                        player: {
                            playing: true,
                            duration: 15,
                        },
                        postTemplate: '',
                        userGroupEffect: 'top',
                        theme: 'primary',
                        postDirection: 'vertical',
                        showSentiment: true,
                        showText: true,
                        postVersion: 2,
                        smartSize: {
                            enabled: true,
                            mode: 'responsive',
                            size: 'xl',
                        },
                    } as PostsWidgetOptions,
                    postCompositionConfigGrid.a
                ),
                label: {
                    titleText: 'Instagram',
                    size: WIDGET_LABEL_SIZE.secondary,
                    enabled: true,
                },
            },
            {
                type: 'postsGrid',
                id: '3',
                name: 'Post column 3',
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                // Note: All global variables like reportingEngine, report, and filters
                                // are injected via PostRequest.getRequests()
                                id: new PostSource({
                                    pageSize: 50,
                                    filters: [
                                        new Filter({
                                            dimensionName: {
                                                LISTENING: 'LISTENING_MEDIA_TYPE',
                                                INBOUND_MESSAGE: 'SN_TYPE',
                                                PLATFORM: 'SN_TYPE',
                                                BENCHMARKING: 'BENCHMARKING_SN_TYPE',
                                            },
                                            values: {
                                                LISTENING: ['FACEBOOK'],
                                                INBOUND_MESSAGE: ['FACEBOOK'],
                                                PLATFORM: ['FACEBOOK'],
                                                BENCHMARKING: ['FACEBOOK#Facebook'],
                                            },
                                        }),
                                    ],
                                    sorts: [
                                        new Sort({
                                            order: 'DESC',
                                            heading: {
                                                LISTENING: 'REACH_COUNT',
                                                INBOUND_MESSAGE: 'INBOUND_COUNT',
                                                PLATFORM: 'TOTAL_ENGAGEMENT',
                                                BENCHMARKING: 'TOTAL_ENGAGEMENT',
                                                CAMPAIGN: 'OUTBOUND_STATUS',
                                            },
                                        }),
                                    ],
                                    includeFaceDetection: false,
                                    timePeriod: {
                                        key: 'last_7_days',
                                    },
                                }) as any,
                                options: {
                                    count: 300,
                                    imagePreload: true,
                                    removeDuplicates: true,
                                    includeFaceDetection: false,
                                    shufflePosts: false,
                                    removeSensitivePosts: true,
                                },
                            },
                        ],
                        format: {
                            type: 'buckets',
                            options: {
                                padding: 1,
                                buckets: {
                                    text: { filter: "post.type == 'text'" },
                                    image: { filter: "post.type == 'image'" },
                                    any: { filter: 'post.type' },
                                },
                                panels: [{ total: 2, buckets: ['any', -1] }],
                            },
                        },
                    },
                ],
                position: {
                    height: '92.56%',
                    width: '31.94%',
                    top: '3.72%',
                    left: '66.04%',
                    portrait: {
                        height: '31.94%',
                        width: '95.84%',
                        top: '66.04%',
                        left: '2.08%',
                    },
                },
                options: Object.assign(
                    {
                        player: {
                            playing: true,
                            duration: 15,
                        },
                        postTemplate: '',
                        userGroupEffect: 'top',
                        theme: 'primary',
                        postDirection: 'vertical',
                        showSentiment: true,
                        imageFaceDetection: false,
                        showText: true,
                        postVersion: 2,
                        smartSize: {
                            enabled: true,
                            mode: 'responsive',
                            size: 'xl',
                        },
                    } as PostsWidgetOptions,
                    postCompositionConfigGrid.a
                ),
                label: {
                    titleText: 'Facebook',
                    size: WIDGET_LABEL_SIZE.secondary,
                    enabled: true,
                },
            },
        ],
        theme: {
            ext: {
                padding: 0,
            },
        },
        // label: {
        //     titleText: 'Posts by Social Network',
        //     enabled: true,
        //     size: LabelSize.primary
        // }
    },
};
